// @vendors
import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

// @context
import { useUI } from '../../../app/context/ui';

// @helpers
import AppHelper from '../../../helpers/AppHelper';
import { types } from '../../../redux/types';

// @services
import EmployeeCompanyServiceNewApi from '../../../services/newApi/EmployeeCompanyServiceNewApi';

const UseRowDetail = (row) => {
    const employeeServiceNewApi = useMemo(() => new EmployeeCompanyServiceNewApi(), []);
    const dispatch = useDispatch();
    const globalState = useSelector((state) => state);
    const stateDetail = globalState?.employeeSelected;
    const { blockUI, snackbarUI } = useUI();
    const [open, setOpen] = useState(false);
    const [employeeInfo, setEmployeeInfo] = useState();

    const handleOpen = async () => {
        if (row?.isDeleted) return;
        if (stateDetail?.detail !== row?.id) return await getEmployeeById();
        saveRowId();
        setOpen(!open);
    };

    const getEmployeeById = async (id) => {
        try {
            const rowId = id ? id : row?.id;
            blockUI.current.open(true);
            const response = await employeeServiceNewApi.getEmployeeById(rowId, row?.companyId);
            setEmployeeInfo(response?.data?.data);
            blockUI.current.open(false);
            setOpen(true);
            return saveRowId();
        } catch (e) {
            blockUI.current.open(false);
            AppHelper.checkError(e, snackbarUI);
        }
    }

    const saveRowId = () => {
        dispatch({
            type: types.ID_EMPLOYEE_SELECTED,
            detail: !stateDetail?.detail || stateDetail?.detail !== row?.id ? row?.id : ''
        });
    }

    return {
        employeeInfo,
        open,
        setOpen,
        handleOpen,
        getEmployeeById
    }
}

export default UseRowDetail